// Флаг — визуальная подсказка к языку, выбранная юрисдикция от него не зависит.
const languageRegions: Record<string, string> = {
  en: 'gb', ru: 'ru', es: 'es', fr: 'fr', de: 'de', pt: 'pt', zh: 'cn', ja: 'jp', ko: 'kr', ar: 'sa',
  it: 'it', nl: 'nl', pl: 'pl', sv: 'se', fi: 'fi', no: 'no', da: 'dk', cs: 'cz', sk: 'sk', hu: 'hu',
  ro: 'ro', bg: 'bg', hr: 'hr', sr: 'rs', sl: 'si', el: 'gr', uk: 'ua', be: 'by', lt: 'lt', lv: 'lv', et: 'ee',
  th: 'th', vi: 'vn', id: 'id', ms: 'my', tl: 'ph', fil: 'ph', hi: 'in', bn: 'bd', ta: 'in', te: 'in',
  mr: 'in', gu: 'in', kn: 'in', ml: 'in', pa: 'in', he: 'il', fa: 'ir', ur: 'pk', tr: 'tr', az: 'az',
  kk: 'kz', uz: 'uz', sw: 'tz', af: 'za', ca: 'es', eu: 'es', gl: 'es', is: 'is', ga: 'ie', cy: 'gb', mt: 'mt',
};
export function localeRegion(code: string, kind: 'language' | 'region'): string {
  if (!code || code === 'international') return 'international';
  if (kind === 'region') {
    if (code === 'us_california') return 'us';
    if (['asia', 'latam'].includes(code)) return 'international';
    return code.toLowerCase() === 'uk' ? 'gb' : code.toLowerCase();
  }
  const [language, region] = code.toLowerCase().split(/[-_]/);
  return region || languageRegions[language] || 'international';
}
